<script>
import Vue from 'vue'
import { VueMasonryPlugin } from 'vue-masonry'
import CardFeed from './components/card-feed'
import Modal from './components/modal'

Vue.use(VueMasonryPlugin)
Vue.config.productionTip = false

new Vue({
  el: '#page',
  components: {
    CardFeed,
    Modal
  }
})
</script>



// WEBPACK FOOTER //
// src/js/app.vue